"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useZoomTracking = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = require("react");
var _client = _interopRequireDefault(require("../client"));
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      (0, _defineProperty2["default"])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
var UPDATE_DELAY = 2000;
var calculateZoomType = function calculateZoomType(zoomRatio) {
  var DEFAULT_RATIO = 1;
  if (zoomRatio > DEFAULT_RATIO) {
    return 'zoom_in';
  } else if (zoomRatio < DEFAULT_RATIO) {
    return 'zoom_out';
  }
  return 'zoom_reset';
};
var useZoomTracking = exports.useZoomTracking = function useZoomTracking(_ref) {
  var _ref$category = _ref.category,
    category = _ref$category === void 0 ? 'admin' : _ref$category,
    formUid = _ref.formUid,
    page = _ref.page,
    section = _ref.section,
    _ref$updateDelay = _ref.updateDelay,
    updateDelay = _ref$updateDelay === void 0 ? UPDATE_DELAY : _ref$updateDelay;
  var lastDevicePixelRatio = (0, _react.useRef)(window.devicePixelRatio);
  var delayingTracking = (0, _react.useRef)(false);
  (0, _react.useEffect)(function () {
    var trackZoomEvents = function trackZoomEvents(zoomRatio) {
      var zoomType = calculateZoomType(zoomRatio);
      _client["default"].trackBrowserZoomed(_objectSpread(_objectSpread(_objectSpread({
        zoom_type: zoomType,
        zoom_percentage: "".concat(Math.round(zoomRatio * 100)),
        category: category,
        page: page
      }, formUid && {
        form_uid: formUid
      }), section && {
        section: section
      }), {}, {
        page_width: window.innerWidth,
        page_height: window.innerHeight,
        screen_width: window.screen.width,
        screen_height: window.screen.height
      }));
    };
    var handleResize = function handleResize() {
      if (!delayingTracking.current) {
        delayingTracking.current = true;
        setTimeout(function () {
          var currentDevicePixelRatio = window.devicePixelRatio;
          var hasChanged = currentDevicePixelRatio !== lastDevicePixelRatio.current;
          if (hasChanged) {
            lastDevicePixelRatio.current = currentDevicePixelRatio;
            trackZoomEvents(currentDevicePixelRatio);
          }
          delayingTracking.current = false;
        }, updateDelay);
      }
    };
    window.addEventListener('resize', handleResize);
    return function () {
      window.removeEventListener('resize', handleResize);
    };
  }, [category, formUid, page, section, updateDelay]);
  return;
};